import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20soft%20color%20gradient%20background%20with%20flowing%20silk%20fabric%20in%20warm%20peach%20rose%20gold%20and%20cream%20tones%2C%20dreamy%20atmospheric%20lighting%2C%20artistic%20feminine%20aesthetic%2C%20minimal%20composition%20with%20smooth%20curves%2C%20editorial%20quality%20with%20soft%20focus&width=1600&height=900&seq=hero-beauty-colors-2026&orientation=landscape"
        alt="美女网站色彩设计 - 优雅柔和的配色背景"
        title="美女网站色彩设计指南 - 探索女性网站视觉美学"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 max-w-3xl leading-tight">
          美女网站色彩设计指南
        </h1>
        <p className="mt-4 md:mt-5 text-sm md:text-lg text-background-200 max-w-xl leading-relaxed">
          探索女性网站色彩搭配的核心技巧，从配色方案到视觉层次，帮助设计师打造高颜值、高转化的美女类网站
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/color-schemes"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            探索配色方案
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/category/design-tips"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            学习设计技巧
          </Link>
        </div>

        <div className="mt-10 md:mt-14 flex items-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-semibold text-background-50">300+</div>
            <div className="text-xs text-background-300 mt-1">品牌案例</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-semibold text-background-50">20套</div>
            <div className="text-xs text-background-300 mt-1">配色方案</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-semibold text-background-50">50K+</div>
            <div className="text-xs text-background-300 mt-1">设计师关注</div>
          </div>
        </div>
      </div>
    </section>
  );
}